export const errorPageContent = (strings: TemplateStringsArray, redirect?: boolean) => {
  const message = strings[0];
  return `
  <html>
	<head>
		<meta charset="utf-8" />
		<meta http-equiv="x-ua-compatible" content="ie=edge" />
		<meta
			name="viewport"
			content="initial-scale=1.0, maximum-scale=2.0, minimum-scale=1.0, user-scalable=no, width=device-width, viewport-fit=cover"
		/>
    ${redirect ? '<meta http-equiv="refresh" content="5;url=/">' : ''}
		<style>
			@font-face {
				font-display: fallback;
				font-family: "Centra No2";
				font-weight: 300 400;
				src: url("https://www.exploretock.com/fonts/centra-no2/CentraNo2-Book.woff2")
						format("woff2"),
					url("https://www.exploretock.com/fonts/centra-no2/CentraNo2-Book.woff")
						format("woff"),
					url("https://www.exploretock.com/fonts/centra-no2/CentraNo2-Book.ttf")
						format("truetype");
			}

			@font-face {
				font-display: fallback;
				font-family: "Centra No2";
				font-weight: 500 600;
				src: url("https://www.exploretock.com/fonts/centra-no2/CentraNo2-Medium.woff2")
						format("woff2"),
					url("https://www.exploretock.com/fonts/centra-no2/CentraNo2-Medium.woff")
						format("woff"),
					url("https://www.exploretock.com/fonts/centra-no2/CentraNo2-Medium.ttf")
						format("truetype");
			}

			@font-face {
				font-display: fallback;
				font-family: "Söhne Schmal";
				font-weight: 700;
				src: url("https://www.exploretock.com/fonts/soehne/soehne-schmal-web-halbfett.woff2")
						format("woff2"),
					url("https://www.exploretock.com/fonts/soehne/soehne-schmal-web-halbfett.woff")
						format("woff"),
					url("https://www.exploretock.com/fonts/soehne/soehne-schmal-web-halbfett.ttf")
						format("truetype");
			}

			html {
				font-size: 62.5%;
				box-sizing: border-box;
				-webkit-font-smoothing: antialiased;
				-moz-osx-font-smoothing: grayscale;
			}
			*,
			*::before,
			*::after {
				box-sizing: inherit;
			}
			body {
				background-color: #ffffff;
				color: #2b2b2b;
				margin: 0;
				font-size: 1.4rem;
				font-family: Centra No2, Helvetica, sans-serif;
				font-weight: 400;
				line-height: 1.43;
				background-color: transparent;
			}

			h1 {
				font-size: 5.6rem;
				line-height: 1;
				font-weight: 700;
				font-family: Söhne Schmal;
			}

			@media (min-width: 960px) {
				h1 {
					font-size: 7.2rem;
				}
			}

			p {
				font-size: 1.6rem;
				line-height: 1.375;
			}

			@media (min-width: 960px) {
				p {
					font-size: 2rem;
					line-height: 1.3;
				}
			}

			.text-center {
				text-align: center;
			}

			.m-auto {
				margin: auto;
			}

			.mb2 {
				margin-bottom: 16px;
			}

			.mb4 {
				margin-bottom: 32px;
			}

			.mb5 {
				margin-bottom: 40px;
			}

			.page {
				height: 100vh;
				width: 100vw;
				display: flex;
				flex-direction: column;
			}

			.logo {
				height: auto;
				width: 84px;
				display: block;
				margin: auto;
			}

			.content {
				background-color: #ffffff;
				padding: 40px 36px 0;
				flex: 1;
			}

			@media (min-width: 600px) {
				.content {
					padding: 40px 70px 0;
				}
			}

			@media (min-width: 960px) {
				.content {
					padding: 40px 200px 0;
				}
			}

			.computer-pizza-bg {
				background-image: url("https://storage.googleapis.com/tock-public-assets/error-page/pizza-computer.svg");
			}

			.computer-pizza-content {
				position: relative;
				height: 147px;
				width: 100%;
				background-position: center;
				background-size: contain;
				background-repeat: no-repeat;
			}

			@media (min-width: 600px) {
				.computer-pizza-content {
					height: 300px;
				}
			}

			@media (min-width: 960px) {
				.computer-pizza-content {
					height: 417px;
					position: absolute;
					left: 0;
					width: 100%;
					background-position-x: 24px;
					background-position-y: 0;
				}
			}

			.cord-bg {
				background-image: url("https://storage.googleapis.com/tock-public-assets/error-page/cord.svg");
			}

			.cord-content {
				position: relative;
				height: 41px;
				width: 100%;
				background-position: top right;
				background-size: contain;
				background-repeat: no-repeat;
				right: -36px;
				top: -41px;
			}

			@media (min-width: 600px) {
				.cord-content {
					height: 80px;
					top: -80px;
					right: -70px;
				}
			}

			@media (min-width: 960px) {
				.cord-content {
					height: 112px;
					top: -112px;
					right: -200px;
				}
			}

			@media (min-width: 960px) {
				.title {
					margin-top: 274px;
				}
			}

			.message {
				max-width: 500px;
			}
		</style>
	</head>

	<body>
		<div class="page">
			<main class="content">
				<div class="computer-pizza-bg computer-pizza-content"></div>
				<h1 class="title text-center mb4">Something’s not right.</h1>
				<p class="text-center mb2 m-auto message">
        ${message}
				</p>
				${redirect ? '' : '<p class="text-center">Please try again soon.</p>'}
				<div class="cord-bg cord-content"></div>
				<img
					alt="Tock logo"
					class="logo"
					src="data:image/svg+xml;base64,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"
				/>
			</main>
		</div>
	</body>
</html>
  `;
};
